<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h2 v-if="customer && !id">
                    New Site for {{ customer.company_name }}
                </h2>
                <h2 v-if="id">
                    Editing site: #{{ site.site_no }} {{ site.name }}
                </h2>
            </div>
        </div>
        <form
            v-if="site"
            action=""
            @submit.prevent="save"
        >
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-group">
                                <label for="name">Name:</label>
                                <input
                                    type="text"
                                    id="name"
                                    v-model="site.name"
                                    class="form-control"
                                    placeholder="Site name"
                                    :class="{ 'is-invalid' : errors.name }"
                                    required
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.name"
                                >{{ errors.name[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label>Site No:</label>
                                <input
                                    type="text"
                                    readonly
                                    :value="site.site_no"
                                    class="form-control"
                                    placeholder="Site No."
                                    :class="{ 'is-invalid' : errors.site_no }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.site_no"
                                >{{ errors.site_no[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="contact_name">Contact Name:</label>
                                <input
                                    type="text"
                                    id="contact_name"
                                    v-model="site.contact_name"
                                    class="form-control"
                                    placeholder="Contact name"
                                    :class="{ 'is-invalid' : errors.contact_name }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.contact_name"
                                >{{ errors.contact_name[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="email">Email Address:</label>
                                <input
                                    type="email"
                                    id="email"
                                    v-model="site.email"
                                    class="form-control"
                                    placeholder="Email Address"
                                    :class="{ 'is-invalid' : errors.email }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.email"
                                >{{ errors.email[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="telephone">Telephone:</label>
                                <input
                                    type="text"
                                    id="telephone"
                                    v-model="site.telephone"
                                    class="form-control"
                                    placeholder="Telephone"
                                    :class="{ 'is-invalid' : errors.telephone }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.telephone"
                                >{{ errors.telephone[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="mobile_number">Mobile:</label>
                                <input
                                    type="text"
                                    id="mobile_number"
                                    v-model="site.mobile_number"
                                    class="form-control"
                                    placeholder="Mobile"
                                    :class="{ 'is-invalid' : errors.mobile_number }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.mobile_number"
                                >{{ errors.mobile_number[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="elighting_service_time">E-Lighting Service Time:</label>
                                <duration-select-component
                                    v-model="site.elighting_service_time"
                                    required
                                />
                            </div>
                            <div class="form-group">
                                <label for="fa_service_time">Fire Alarm Service Time:</label>
                                <duration-select-component
                                    v-model="site.fa_service_time"
                                    required
                                />
                            </div>
                            <div class="form-group">
                                <label for="fe_service_time">Fire Exitinguisher Service Time:</label>
                                <duration-select-component
                                    v-model="site.fe_service_time"
                                    required
                                />
                            </div>
                            <div class="form-group">
                                <label for="ra_service_time">Risk Assessment Time:</label>
                                <duration-select-component
                                    v-model="site.ra_service_time"
                                    required
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <address-form
                                v-if="site.address"
                                :address="site.address"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="row"
                v-if="site.id"
            >
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <h3>Service Reminders</h3>
                            <div>
                                <label><input
                                    type="checkbox"
                                    v-model="site.service_reminder_disabled"
                                > Service reminders disabled</label>
                            </div>
                            <p v-if="!site.service_reminder_disabled">
                                For reminders that occur more than once a year create multiple reminders for different
                                months
                            </p>
                            <p
                                class="italic"
                                v-if="!site.service_reminder_disabled"
                            >
                                E.g. A 6 month reminder would have a reminder for January and a reminder for July
                            </p>

                            <table
                                class="table"
                                v-if="!site.service_reminder_disabled"
                            >
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>Month</th>
                                        <th>Notes</th>
                                        <th>
                                        <!-- options -->
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(r, i) in site.service_reminders"
                                        :key="'reminder_' + i"
                                    >
                                        <td>
                                            <select
                                                name="reminder_type"
                                                v-model="r.type"
                                                placeholder="Type"
                                                class="form-control"
                                            >
                                                <option
                                                    :value="null"
                                                    disabled
                                                >
                                                    Choose type...
                                                </option>
                                                <option
                                                    v-for="type in serviceReminderTypes"
                                                    :key="type.value"
                                                    :value="type.value"
                                                >
                                                    {{ type.label }}
                                                </option>
                                            </select>
                                        </td>

                                        <td>
                                            <select
                                                name="reminder_month"
                                                v-model="r.month"
                                                placeholder="Month"
                                                class="form-control"
                                            >
                                                <option
                                                    :value="null"
                                                    disabled
                                                >
                                                    Choose month...
                                                </option>
                                                <option value="1">
                                                    January
                                                </option>
                                                <option value="2">
                                                    Feburary
                                                </option>
                                                <option value="3">
                                                    March
                                                </option>
                                                <option value="4">
                                                    April
                                                </option>
                                                <option value="5">
                                                    May
                                                </option>
                                                <option value="6">
                                                    June
                                                </option>
                                                <option value="7">
                                                    July
                                                </option>
                                                <option value="8">
                                                    August
                                                </option>
                                                <option value="9">
                                                    September
                                                </option>
                                                <option value="10">
                                                    October
                                                </option>
                                                <option value="11">
                                                    November
                                                </option>
                                                <option value="12">
                                                    December
                                                </option>
                                                <option value="13">
                                                    Over Due
                                                </option>
                                            </select>
                                        </td>

                                        <td>
                                            <textarea
                                                name="reminder_notes"
                                                rows="1"
                                                class="form-control"
                                                v-model="r.notes"
                                            />
                                        </td>

                                        <td>
                                            <button
                                                class="btn btn-sm btn-outline-danger"
                                                type="button"
                                                @click.prevent="removeReminder(i)"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <button
                                class="btn btn-outline-info"
                                type="button"
                                v-if="!site.service_reminder_disabled"
                                @click="addReminder"
                            >
                                <i class="fa fa-plus" /> Add Reminder
                            </button>
                            <div
                                class="row"
                                v-if="site.service_reminder_disabled"
                            >
                                <div class="col-sm-12">
                                    <textarea
                                        v-model="site.service_reminder_note"
                                        rows="3"
                                        class="form-control"
                                        placeholder="Service reminder notes..."
                                    />
                                    <small
                                        class="form-error"
                                        v-if="errors.service_reminder_note"
                                    >{{ errors.service_reminder_note[0] }}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="row"
                v-if="site.id"
            >
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <h3>Fire Alarm Settings</h3>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-3">
                                    <label for="fire_alarm_type">Fire Alarm Type:</label>
                                    <select
                                        name="fire_alarm_type"
                                        id="fire_alarm_type"
                                        v-model="site.fire_alarm_type"
                                        class="form-control"
                                    >
                                        <option disabled>
                                            Select
                                        </option>
                                        <option value="L1">
                                            L1
                                        </option>
                                        <option value="L2">
                                            L2
                                        </option>
                                        <option value="L3">
                                            L3
                                        </option>
                                        <option value="L4">
                                            L4
                                        </option>
                                        <option value="L5">
                                            L5
                                        </option>
                                        <option value="P1">
                                            P1
                                        </option>
                                        <option value="P2">
                                            P2
                                        </option>
                                        <option value="M">
                                            M
                                        </option>
                                        <option value="X">
                                            X
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <label for="cie_manufacturer">The Control Indication Equipment (CIE) Type /
                                        Manufacturer</label>
                                    <input
                                        type="text"
                                        v-model="site.cie_manufacturer"
                                        placeholder="Type here.."
                                        class="form-control"
                                    >
                                </div>

                                <div class="col-6">
                                    <label for="cie_protocol">The Control Indication Equipment (CIE) system
                                        protocol</label>
                                    <select
                                        name="cie_protocol"
                                        id="cie_protocol"
                                        v-model="site.cie_protocol"
                                        class="form-control"
                                    >
                                        <option
                                            disabled
                                            :value="null"
                                        >
                                            Select
                                        </option>
                                        <option>Conventional</option>
                                        <option>Addressable</option>
                                        <option>Bi-Wire</option>
                                    </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <label for="device_system_protocol">Device system protocol</label>
                                    <input
                                        type="text"
                                        v-model="site.device_system_protocol"
                                        placeholder="Type here.."
                                        class="form-control"
                                    >
                                </div>

                                <div class="col-6">
                                    <label for="cie_max_zones">The Control Indication Equipment (CIE) Maximum Number of
                                        Zones</label>
                                    <input
                                        type="number"
                                        step="1"
                                        min="0"
                                        max="200"
                                        v-model="site.cie_max_zones"
                                        placeholder="1"
                                        class="form-control"
                                    >
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <label for="panel_user_code">Fire Panel User Code</label>
                                    <input
                                        type="text"
                                        v-model="site.panel_user_code"
                                        placeholder="Type here.."
                                        class="form-control"
                                    >
                                </div>

                                <div class="col-6">
                                    <label for="panel_engineer_code">Fire Panel Engineer Code</label>
                                    <input
                                        type="text"
                                        v-model="site.panel_engineer_code"
                                        placeholder="Type here.."
                                        class="form-control"
                                    >
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="mb-3">
                                        <label for="fire_panel_location">Fire Panel Location</label>
                                        <input
                                            type="text"
                                            v-model="site.fire_panel_location"
                                            placeholder="Type here.."
                                            class="form-control"
                                        >
                                    </div>
                                    <div>
                                        <label for="fire_panel_photo">Fire Panel</label>
                                        <fire-alarm-upload-preview
                                            v-if="site.fire_panel_photo"
                                            :upload="site.fire_panel_photo"
                                            alt="Fire Panel Photo"
                                            @change="uploadChanged($event, 'fire_panel_photo')"
                                        />
                                        <p v-else>
                                            No photo available
                                        </p>
                                        <fire-alarm-upload-preview
                                            v-if="site.fire_panel_pdf"
                                            :upload="site.fire_panel_pdf"
                                            alt="Fire Panel PDF"
                                            @change="uploadChanged($event, 'fire_panel_pdf')"
                                        />
                                    </div>
                                </div>
                                <div class="col-6">
                                    <label for="zone_plan_photo">Zone Plan</label>
                                    <fire-alarm-upload-preview
                                        v-if="site.zone_plan_photo"
                                        :upload="site.zone_plan_photo"
                                        alt="Zone Plan Photo"
                                        @change="uploadChanged($event, 'zone_plan_photo')"
                                    />
                                    <p v-else>
                                        No photo available
                                    </p>
                                    <fire-alarm-upload-preview
                                        v-if="site.zone_plan_pdf"
                                        :upload="site.zone_plan_pdf"
                                        alt="Zone Plan PDF"
                                        @change="uploadChanged($event, 'zone_plan_pdf')"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="row"
                v-if="site.id"
            >
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <h3>Fire Alarm Devices</h3>
                            <p>
                                The following devices will be used when creating a Fire Alarm Test form for this
                                customer
                                site.
                            </p>
                            <table
                                class="table"
                                id="devices-table"
                            >
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th>Zone</th>
                                        <th>Detector No.</th>
                                        <th>Type</th>
                                        <th>In Order</th>
                                        <th>Location</th>
                                        <th>Year</th>
                                        <th>
                                        <!-- options -->
                                        </th>
                                    </tr>
                                </thead>
                                <draggable
                                    v-model="site.devices"
                                    tag="tbody"
                                    handle=".drag-handle"
                                >
                                    <tr
                                        v-for="(device, index) of site.devices"
                                        :key="'device_' + index"
                                        :class="{'invalid' : isDeviceInvalid(device)}"
                                    >
                                        <td class="drag-handle-col">
                                            <span class="drag-handle">
                                                <i class="fas fa-arrows-alt-v" />
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="device.zone"
                                                placeholder="Zone"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="device.detector_no"
                                                placeholder="Detector No."
                                            >
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="device.type"
                                                placeholder="Type"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="device.inorder"
                                                placeholder="In Order"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="device.location"
                                                placeholder="Location"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                min="1940"
                                                max="2100"
                                                step="1"
                                                class="form-control"
                                                v-model="device.year"
                                                placeholder="Year"
                                            >
                                        </td>
                                        <td>
                                            <button
                                                class="btn btn-sm btn-outline-danger"
                                                type="button"
                                                @click.prevent="removeDevice(index)"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </draggable>
                                <tfoot>
                                    <tr>
                                        <td
                                            colspan="7"
                                            class="text-right"
                                        >
                                            <div
                                                style="display: flex; align-items: center; justify-content: space-between; gap: 2rem"
                                            >
                                                <CsvImport
                                                    button-text="Import Devices"
                                                    example-url="/examples/fire_devices_import.csv"
                                                    :columns="['zone', 'detector_no', 'type', 'inorder', 'location', 'year']"
                                                    @imported="handleDeviceImport"
                                                />
                                                <button
                                                    class="btn btn-outline-info"
                                                    type="button"
                                                    @click.prevent="addDevice()"
                                                >
                                                    <i class="fa fa-plus" /> Add Device
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="row"
                v-if="site.id"
            >
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <h3>Emergency Lighting</h3>
                            <p>
                                The following lights will be used when creating a Emergency Lighting Test form for this
                                customer site.
                            </p>
                            <table
                                class="table lighting-table"
                                id="lights-table"
                            >
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th class="th td td-sw-no">
                                            T.S No
                                        </th>
                                        <th class="th td td-light-no">
                                            Li No
                                        </th>
                                        <th class="th td td-maintained">
                                            Main
                                        </th>
                                        <th class="th td td-type">
                                            Type
                                        </th>
                                        <th class="th td td-location-light">
                                            Location of Light
                                        </th>
                                        <th class="th td td-location-switch">
                                            Location of Switch
                                        </th>
                                        <th>
                                        <!-- options -->
                                        </th>
                                    </tr>
                                </thead>
                                <draggable
                                    v-model="site.lights"
                                    tag="tbody"
                                    handle=".drag-handle"
                                >
                                    <tr
                                        v-for="(light, i) in site.lights"
                                        :key="'light_' + i"
                                        :class="{'invalid' : isLightInvalid(light)}"
                                    >
                                        <td class="drag-handle-col">
                                            <span class="drag-handle">
                                                <i class="fas fa-arrows-alt-v" />
                                            </span>
                                        </td>
                                        <td class="td td-sw-no">
                                            {{ light.sw_no || "-" }}
                                        </td>
                                        <td class="td td-light-no">
                                            {{ light.light_no || "-" }}
                                        </td>
                                        <td class="td td-maintained text-center">
                                            {{ light.maintained ? "Y" : "N" }}
                                        </td>
                                        <td class="td td-type">
                                            <div class="light-type-display">
                                                <img
                                                    v-if="getLightTableImage(light)"
                                                    :src="getLightTableImage(light)"
                                                    class="light-type-display__image"
                                                    alt="Light type"
                                                >
                                                <span>{{ getLightTypeDisplay(light) }}</span>
                                            </div>
                                        </td>
                                        <td class="td td-light-location">
                                            {{ light.light_location || "-" }}
                                        </td>
                                        <td class="td td-switch-location">
                                            {{ light.switch_location || "-" }}
                                        </td>
                                        <td class="td td-buttons">
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-outline-primary mr-1"
                                                @click="openEditLightModal(i)"
                                            >
                                                <i class="fa fa-pencil-alt" />
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-outline-danger"
                                                @click="promptLightDeletion(i)"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </draggable>
                                <tfoot>
                                    <tr>
                                        <td
                                            class="text-right"
                                            colspan="8"
                                        >
                                            <button
                                                class="btn btn-outline-info"
                                                type="button"
                                                @click="openAddLightModal"
                                            >
                                                <i class="fa fa-plus" /> Add Light
                                            </button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                            <ul class="key">
                                <li>T.S No - Test Switch Number</li>
                                <li>Li No - Light Number</li>
                                <li>Main - Maintained</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="row"
                v-if="site.id"
            >
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <h3>Servicing Items</h3>
                            <p>
                                The following service items will be used when creating a Fire Extinguisher Service form
                                for this customer site.
                            </p>
                            <p class="text-info">
                                <span class="bold">Note on costs:</span>
                                Service costs will only update when the site has been saved.
                            </p>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th class="td-no">
                                            No
                                        </th>
                                        <th class="td-type">
                                            Type
                                        </th>
                                        <th
                                            class="td-ltd"
                                            colspan="2"
                                        >
                                            L.T.D
                                        </th>
                                        <th class="td-size">
                                            Size
                                        </th>
                                        <th class="td-location">
                                            Location
                                        </th>
                                        <th class="td-non-main text-center">
                                            Non-Main
                                        </th>
                                        <th class="td-non-main text-center">
                                            Basic Serv
                                        </th>
                                        <th class="td-non-main text-center">
                                            Ext Serv
                                        </th>
                                        <th>Cost</th>
                                        <th class="td-options">
                                        <!-- options -->
                                        </th>
                                    </tr>
                                </thead>
                                <draggable
                                    v-model="site.service_items"
                                    tag="tbody"
                                    handle=".drag-handle"
                                >
                                    <tr
                                        v-for="(item, index) in site.service_items"
                                        :key="'service_item_' + index"
                                    >
                                        <td class="drag-handle-col">
                                            <span class="drag-handle">
                                                <i class="fas fa-arrows-alt-v" />
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                v-model="item.no"
                                                placeholder="No."
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td style="width: 13rem">
                                            <select
                                                v-model="item.product_id"
                                                placeholder="Select type"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                                <option
                                                    value=""
                                                    disabled
                                                >
                                                    Select type...
                                                </option>
                                                <option
                                                    v-for="(product, pidx) in products"
                                                    :value="product.id"
                                                    :key="'product_' + pidx"
                                                >
                                                    {{ product.name }}
                                                </option>
                                            </select>
                                            <expiry-notice
                                                :products="products"
                                                :item="item"
                                            />
                                        </td>

                                        <td style="width: 7rem">
                                            <select
                                                v-model="item.ltd_month"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                                <option>N/A</option>
                                                <option>Jan</option>
                                                <option>Feb</option>
                                                <option>Mar</option>
                                                <option>Apr</option>
                                                <option>May</option>
                                                <option>Jun</option>
                                                <option>Jul</option>
                                                <option>Aug</option>
                                                <option>Sep</option>
                                                <option>Oct</option>
                                                <option>Nov</option>
                                                <option>Dec</option>
                                            </select>
                                        </td>

                                        <td>
                                            <input
                                                type="text"
                                                v-model="item.ltd"
                                                placeholder="L.T.D"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td>
                                            <select
                                                name="size[]"
                                                v-model="item.size"
                                                class="form-control"
                                            >
                                                <option
                                                    value=""
                                                    disabled
                                                >
                                                    Select size
                                                </option>
                                                <option
                                                    :value="variation.name"
                                                    v-for="(variation, vidx) in getProductVariations(item.product_id)"
                                                    :key="'variation_'+vidx"
                                                >
                                                    {{ variation.name }}
                                                </option>
                                            </select>
                                        </td>

                                        <td class="td-location">
                                            <input
                                                type="text"
                                                v-model="item.location"
                                                placeholder="Location"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td class="td-non-main text-center">
                                            <input
                                                type="checkbox"
                                                v-model="item.non_main"
                                                @change="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td class="td-non-main text-center">
                                            <input
                                                type="checkbox"
                                                :checked="!item.es_required"
                                                disabled
                                            >
                                        </td>

                                        <td class="td-non-main text-center">
                                            <input
                                                type="checkbox"
                                                :checked="item.es_required"
                                                disabled
                                            >
                                        </td>

                                        <td>
                                            <input
                                                class="form-control"
                                                type="number"
                                                step="0.01"
                                                readonly
                                                :value="item.cost | money"
                                            >
                                        </td>

                                        <td class="text-center">
                                            <button
                                                class="btn btn-outline-danger btn-sm"
                                                @click="removeServiceItem(index)"
                                                type="button"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </draggable>
                                <tfoot>
                                    <tr>
                                        <td
                                            colspan="12"
                                            class="text-right"
                                        >
                                            <button
                                                class="btn btn-outline-info"
                                                @click="addServiceItem()"
                                                type="button"
                                            >
                                                <i class="fa fa-plus" /> Add Item
                                            </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            colspan="9"
                                            class="bold"
                                        >
                                            Site Service Cost
                                        </td>
                                        <td colspan="2">
                                            £{{ serviceFee | money }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            colspan="9"
                                            class="bold"
                                        >
                                            Service Total Cost
                                        </td>
                                        <td
                                            colspan="3"
                                            class="underline"
                                        >
                                            £{{ serviceTotal | money }}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>

                            <h3>Servicing Item Totals</h3>

                            <table
                                class="table"
                                v-if="serviceItemsTotals.length"
                            >
                                <thead>
                                    <tr>
                                        <th style="width: 3rem">
                                            Quantity
                                        </th>
                                        <th>Item</th>
                                        <th class="text-right">
                                            £/each
                                        </th>
                                        <th class="text-right">
                                            Total
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="item in serviceItemsTotals"
                                        :key="item.product_id+'_'+item.size"
                                    >
                                        <td style="width: 3rem">
                                            {{ item.quantity }} x
                                        </td>
                                        <td>{{ item.product_name }} - {{ item.size }}</td>
                                        <td class="text-right">
                                            £{{ (item.cost) | money }} each
                                        </td>
                                        <td
                                            class="text-right"
                                            style="text-decoration: underline;"
                                        >
                                            £{{ (item.cost * item.quantity) | money }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <ul class="key">
                                <li>L.T.D - Last Test Date</li>
                                <li>Non-main - Non Maintained</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="row"
                v-if="site.id"
            >
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <h3>Fire Alarm Batteries</h3>
                            <table class="table">
                                <thead>
                                    <th>Size (Amps)</th>
                                    <th>Volts</th>
                                    <th>Amps</th>
                                    <th>Year</th>
                                    <th>&nbsp;</th>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(battery, index) in site.batteries"
                                        :key="'battery_' + index"
                                    >
                                        <td>
                                            <input
                                                type="number"
                                                v-model="battery.size"
                                                step="0.001"
                                                min="0"
                                                class="form-control"
                                                placeholder="Size (Amps)"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                v-model="battery.volts"
                                                step="0.001"
                                                min="0"
                                                class="form-control"
                                                placeholder="Volts"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                v-model="battery.amps"
                                                step="0.001"
                                                min="0"
                                                class="form-control"
                                                placeholder="Amps"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                v-model="battery.year"
                                                step="1"
                                                min="1990"
                                                class="form-control"
                                                placeholder="Year"
                                            >
                                        </td>
                                        <td class="text-right">
                                            <button
                                                class="btn btn-outline-danger btn-sm"
                                                @click="removeBattery(index)"
                                                type="button"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td
                                            colspan="5"
                                            class="text-right"
                                        >
                                            <button
                                                class="btn btn-outline-info"
                                                @click="addBattery()"
                                                type="button"
                                                v-show="site.batteries && site.batteries.length < 4"
                                            >
                                                <i class="fa fa-plus" /> Add Battery
                                            </button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <engineer-notes
                v-if="site.id"
                :site-id="site.id"
            />

            <div
                class="card"
                v-if="site.id"
            >
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Site Products and Keys</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <site-products
                                :site-id="site.id"
                                @change="siteProductsChanged"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <h3>Intruder Alarm Form Fields</h3>

                    <text-row
                        id="main_cp_location"
                        v-model="site.form_fields.main_cp_location"
                        label="Main control panel location:"
                    />

                    <text-row
                        id="panel_master_code"
                        v-model="site.form_fields.panel_master_code"
                        label="Panel master code:"
                    />

                    <text-row
                        id="panel_engineer_code"
                        v-model="site.form_fields.panel_engineer_code"
                        label="Panel engineer code:"
                    />

                    <intruder-alarm-zones
                        hide-testing
                        v-model="site.form_fields.testItems"
                    />

                    <select-row
                        id="system_monitor_type"
                        v-model="site.form_fields.system_monitor_type"
                        label="System monitoring type"
                        :options="['Bells only', 'Auto dialer', 'Monitored - keyholder', 'Monitored - police']"
                    />

                    <text-row
                        id="entry_routes_secs"
                        v-model="site.form_fields.entry_routes_secs"
                        label="Entry routes time:"
                        type="number"
                        step="1"
                        min="0"
                    />

                    <text-row
                        id="exit_routes_secs"
                        v-model="site.form_fields.exit_routes_secs"
                        label="Exit routes time:"
                        type="number"
                        step="1"
                        min="0"
                    />

                    <text-row
                        id="no_keypads"
                        v-model="site.form_fields.no_keypads"
                        label="Number of keypads on the system:"
                        type="number"
                        step="1"
                        min="0"
                    />

                    <text-row
                        v-for="(keypad, index) in site.form_fields.keypads"
                        :key="'keypad_' + index"
                        :id="'keypad_location[' + index + ']'"
                        v-model="keypad.location"
                        :label="'Keypad ' + (index + 1) + ' location:'"
                    />

                    <text-row
                        id="no_bell_boxes"
                        v-model="site.form_fields.no_bell_boxes"
                        label="Number of bell boxes in the system:"
                        type="number"
                        step="1"
                        min="0"
                    />

                    <div
                        class="row"
                        v-for="(bellBox, index) in site.form_fields.bell_boxes"
                        :key="'bellbox_' + index"
                    >
                        <div class="col-xs-8 col-sm-6 col-md-3">
                            <label>Bell box #{{ index + 1 }} location:</label>
                        </div>
                        <div class="col-xs-4 col-sm-6 col-md-3">
                            <input
                                type="text"
                                placeholder="Type location..."
                                class="form-control"
                                v-model="bellBox.location"
                            >
                        </div>
                        <div class="col-xs-8 col-sm-6 col-md-3">
                            <label>#{{ index + 1 }} Tested and working:</label>
                        </div>
                    </div>

                    <select-row
                        label="Is the site monitored by a Monitoring Station (ARC)?"
                        id="monitoring_station"
                        v-model="site.form_fields.monitoring_station"
                    />
                    <select-row
                        v-show="site.form_fields.monitoring_station === 'Yes'"
                        label="Is the site monitored by Sia or Fast Format?"
                        id="sia_fast_format"
                        v-model="site.form_fields.sia_fast_format"
                        :options="['Sia', 'Fast Format']"
                    />

                    <select-row
                        v-show="site.form_fields.monitoring_station === 'Yes'"
                        :label="'Is the site monitored by ' +companyName+ '?'"
                        id="diamond_fire_monitored"
                        v-model="site.form_fields.diamond_fire_monitored"
                    />

                    <text-row
                        v-show="site.form_fields.diamond_fire_monitored === 'Yes'"
                        type="number"
                        step="1"
                        v-model="site.form_fields.chip_number"
                        label="What is the Chip Number"
                        id="chip_number"
                    />

                    <div v-show="site.form_fields.sia_fast_format === 'Fast Format'">
                        <div class="row">
                            <div class="col-12">
                                <label>Please enter Fast Format Channels:</label>
                            </div>
                        </div>
                        <div
                            class="row"
                            v-for="n in 8"
                            :key="'ff_'+n"
                        >
                            <div class="col-sm-1">
                                {{ n }}.
                            </div>
                            <div class="col-sm-11">
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="site.form_fields['fast_channel_' + n]"
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Nurse Call Devices</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 10rem">
                                            Device No.
                                        </th>
                                        <th style="width: 17rem">
                                            Device Type
                                        </th>
                                        <th colspan="2">
                                            Location
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(device, index) in site.nurse_call_devices"
                                        :key="index"
                                    >
                                        <td>
                                            <input
                                                v-model="device.number"
                                                type="text"
                                                class="form-control"
                                                placeholder="Device No."
                                            >
                                        </td>
                                        <td>
                                            <select
                                                v-model="device.type"
                                                class="form-control"
                                            >
                                                <option value="">
                                                    Select
                                                </option>
                                                <option>Call point</option>
                                                <option>Display screen</option>
                                                <option>Sounder</option>
                                                <option>Monitoring point</option>
                                                <option>Computer connection</option>
                                                <option>Pull cord</option>
                                                <option>Light</option>
                                                <option>Repeater panel</option>
                                                <option>Network splitter</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                v-model="device.location"
                                                type="text"
                                                class="form-control"
                                                placeholder="Location"
                                            >
                                        </td>
                                        <td
                                            class="text-right"
                                            style="width: 3rem"
                                        >
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-outline-danger"
                                                @click.prevent="removeNurseCallDevice(index)"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="text-right">
                                <button
                                    class="btn btn-primary"
                                    @click.prevent="addNurseCallDevice"
                                >
                                    <i class="fa fa-plus" /> Add Device
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Domestic Fire Alarm Devices</h3>
                            <p>
                                The following devices will be used when creating a Domestic Fire Alarm Service form for this site.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 8rem">
                                            Device No.
                                        </th>
                                        <th>
                                            Location
                                        </th>
                                        <th>
                                            Interlink Test (If Fitted)
                                        </th>
                                        <th style="width: 10rem">
                                            Installation Year
                                        </th>
                                        <th style="width: 10rem">
                                            Battery Date
                                        </th>
                                        <th style="width: 3rem" />
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(device, index) in site.domestic_fire_alarm_devices"
                                        :key="index"
                                    >
                                        <td>
                                            <input
                                                v-model="device.device_no"
                                                type="number"
                                                step="1"
                                                min="0"
                                                class="form-control"
                                                placeholder="Device No."
                                            >
                                        </td>
                                        <td>
                                            <input
                                                v-model="device.location"
                                                type="text"
                                                class="form-control"
                                                placeholder="Location"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                v-model="device.interlink_test"
                                                type="text"
                                                class="form-control"
                                                placeholder="Interlink Test"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                v-model="device.install_date"
                                                type="number"
                                                step="1"
                                                class="form-control"
                                                placeholder="Year"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                v-model="device.battery_date"
                                                type="text"
                                                class="form-control"
                                                placeholder="Battery Date"
                                            >
                                        </td>
                                        <td class="text-right">
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-outline-danger"
                                                @click.prevent="removeDomesticFireAlarmDevice(index)"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="text-right">
                                <button
                                    class="btn btn-primary"
                                    type="button"
                                    @click.prevent="addDomesticFireAlarmDevice"
                                >
                                    <i class="fa fa-plus" /> Add Device
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <button
                                type="submit"
                                class="btn btn-primary"
                            >
                                Save
                            </button>
                            <button
                                class="btn btn-outline-danger"
                                @click.prevent="deleteSite"
                            >
                                <i class="fa fa-trash" /> Delete
                            </button>
                            <router-link
                                :to="{name:'office.customers.show', params: { id: customer_id }}"
                                class="btn btn-outline-info"
                            >
                                Back to customer
                            </router-link>
                            <div
                                class="loading"
                                v-if="loading"
                            >
                                <span>Loading
                                    <div class="fa fa-spinner fa-spin" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <e-lighting-light-modal
            ref="lightModal"
            :show-high="false"
            :show-not-accessible="false"
            :show-tested="false"
            @save="saveLightFromModal"
            @request-delete="promptLightDeletion"
        />
    </div>
</template>

<script>
import AddressForm from "../AddressForm.vue";
import SiteService from "../../../services/SitesService";
import CustomerService from "../../../services/CustomerService";
import ProductsService from "../../../services/ServiceProductsService";
import draggable from "vuedraggable";
import UsesInfoMessage from "../../../mixins/UsesInfoMessage";
import PostcodeFeeService from "../../../services/PostcodeFeeService";
import SiteProducts from "../../SiteProductsComponent";
import EngineerNotes from "../../forms/parts/EngineerNotesComponent";
import TextRow from "../../forms/parts/TextRowComponent";
import SelectRow from "../../forms/parts/SelectRowComponent";
import IntruderAlarmZones from "../../forms/parts/IntruderAlarmZones";
import ServiceReminderTypeService from "../../../services/ServiceReminderTypeService";
import FireAlarmUploadPreview from "../../forms/parts/FireAlarmUploadPreview.vue";
import DurationSelectComponent from "../../forms/parts/DurationSelectComponent.vue";
import ExpiryNotice from "../service-products/ExpiryNotice.vue";
import CsvImport from "../CsvImport.vue";
import ELightingLightModal from "../../forms/parts/ELightingLightModal.vue";
import UploadService from "../../../services/UploadService";
import UsesElightingLights from "../../../mixins/UsesElightingLights";

export default {
    components: {
        CsvImport,
        ExpiryNotice,
        DurationSelectComponent,
        FireAlarmUploadPreview,
        AddressForm,
        draggable,
        SiteProducts,
        EngineerNotes,
        TextRow,
        SelectRow,
        IntruderAlarmZones,
        ELightingLightModal,
    },
    mixins: [UsesInfoMessage, UsesElightingLights],
    props: {
        customer_id: {
            required: true,
        },
        id: {
            required: false,
            default: null,
        },
    },
    data: function () {
        return {
            site: {
                devices: [{}],
                lights: [],
                service_items: [{}],
                service_reminders: [],
                batteries: [],
                form_fields: {},
                domestic_fire_alarm_devices: [],
            },
            customer: {},
            service: SiteService,
            errors: {},
            loading: false,
            products: [],
            serviceFee: 0,
            unitServiceFee: 0,
            companyName: window.SystemSettings.company_name,
            serviceReminderTypes: [],
        };
    },

    computed: {
        serviceTotal() {
            if (!this.serviceFee) {
                return "0.00";
            }

            let total = 0;
            this.site.service_items.forEach((item) => {
                total += item.cost;
            });

            total += this.serviceFee;

            return total;
        },

        serviceItemsTotals() {
            const items = [];

            this.site.service_items.forEach((serviceItem) => {
                if (!serviceItem.product_id || !serviceItem.size) {
                    return;
                }
                const itemIndex = items.findIndex(
                    (i) =>
                        i.product_id == serviceItem.product_id &&
                        serviceItem.size == i.size &&
                        i.cost == serviceItem.cost
                );
                const product = this.products.find(
                    (p) => p.id == serviceItem.product_id
                );
                if (!product) {
                    console.error(
                        `Product with ID ${serviceItem.product_id} does not exist but is still being used`
                    );
                    return;
                }
                const item =
                    itemIndex !== -1
                        ? items[itemIndex]
                        : {
                            product_id: serviceItem.product_id,
                            product_name: product.name,
                            size: serviceItem.size,
                            quantity: 0,
                            cost: serviceItem.cost,
                        };

                item.quantity++;

                if (itemIndex !== -1) {
                    items[itemIndex] = item;
                    return;
                }
                items.push(item);
            });

            return items;
        },
    },

    mounted: function () {
        this.getCustomer();
        this.resetForm();
        this.loadProducts();
        this.loadServiceReminderTypes();
        if (this.id !== null) {
            this.getSite();
        }
    },

    methods: {
        resetForm: function () {
            this.site = {
                id: this.id,
                customer_id: this.customer_id,
                address: {
                    address_line_1: "",
                    address_line_2: "",
                    address_line_3: "",
                    town: "",
                    region: "",
                    country: "",
                    postcode: "",
                },
                devices: [{}],
                lights: [],
                service_items: [{}],
                serviceFee: 0,
                unitServiceFee: 0,
                form_fields: {},
                domestic_fire_alarm_devices: [],
            };
        },

        loadServiceReminderTypes: function () {
            ServiceReminderTypeService.index().then((res) => {
                this.serviceReminderTypes = ServiceReminderTypeService.toOptions(res.data);
            }).catch(() => {
                alert("Error: Could not load service reminder types");
            });
        },

        getCustomer: function () {
            this.loading = true;
            CustomerService.get(this.customer_id)
                .then((res) => {
                    this.customer = res.data;
                    this.loading = false;
                })
                .catch((err) => {
                    alert("Error: Could not load customer");
                    this.$router.push({name: "office.customers.search"});
                });
        },

        getSite: function () {
            this.loading = true;
            SiteService.get(this.id).then(
                (res) => {
                    let site = {...res.data};
                    if (typeof site.devices === "undefined") {
                        site.devices = [{}];
                    }
                    if (typeof site.lights === "undefined") {
                        site.lights = [];
                    }
                    site.lights = this.normalizeLightsCollection(
                        site.lights,
                        { markAsExisting: true }
                    );
                    if (typeof site.service_items === "undefined") {
                        site.service_items = [{}];
                    }
                    if (typeof site.batteries === "undefined") {
                        site.batteries = [{}];
                    }
                    if (!Array.isArray(site.domestic_fire_alarm_devices)) {
                        site.domestic_fire_alarm_devices = [];
                    }
                    if (typeof site.form_fields === "undefined") {
                        site.form_fields = {};
                    }
                    if (Array.isArray(site.form_fields)) {
                        let formFields = {};
                        site.form_fields.forEach((field) => {
                            try {
                                formFields[field.name] = JSON.parse(
                                    field.value
                                );
                            } catch (e) {
                                formFields[field.name] = field.value;
                            }
                        });
                        site.form_fields = formFields;
                    }
                    this.site = site;
                    this.getServiceFee();
                    this.loading = false;
                    window.metaTitle("Site | " + this.site.name);
                },
                (err) => {
                    alert("Error: Could not load site");
                    this.$router.push({
                        name: "office.customers.show",
                        params: {id: this.customer_id},
                    });
                }
            );
        },

        save: function () {
            let errorRows = [];
            if (
                this.site.id &&
                this.site.lights &&
                this.site.lights.length > 0
            ) {
                errorRows = this.site.lights.filter(this.isLightInvalid);
                if (errorRows.length > 0) {
                    window.alert(
                        `Error: ${errorRows.length} light(s) are missing required details`
                    );
                    document.getElementById("lights-table").scrollIntoView();
                    return;
                }
            }
            if (
                this.site.id &&
                this.site.devices &&
                this.site.devices.length > 0
            ) {
                errorRows = this.site.devices.filter(this.isDeviceInvalid);
                if (errorRows.length > 0) {
                    window.alert(
                        `Error: ${errorRows.length} device(s) are missing their locations`
                    );
                    document.getElementById("devices-table").scrollIntoView();
                    return;
                }
            }
            const data = window._.assign({}, this.site.address, this.site);
            if (data.lights) {
                data.lights = this.serializeLightsForSave(data.lights, "site");
            }
            this.loading = true;
            this.service
                .updateOrCreate(data)
                .then((xhr) => {
                    alert("Site saved");
                    if (!this.site.id) {
                        this.$router.push({
                            name: "office.sites.edit",
                            params: {id: this.site.id},
                        });
                    }
                    this.getSite();
                    this.getServiceFee();
                })
                .catch((error) => {
                    this.loading = false;
                    this.errors = error.response.data.errors;
                    alert("There was an error saving the site");
                });
        },

        deleteSite: function () {
            if (confirm("Are you sure you want to delete this site?")) {
                this.loading = true;
                SiteService.delete(this.site)
                    .then((res) => {
                        this.loading = false;
                        alert("Site deleted successfully");
                        this.$router.push({
                            name: "office.customers.show",
                            params: {id: this.customer_id},
                        });
                    })
                    .catch((err) => {
                        this.loading = false;
                        alert("Error: Could not delete this site");
                    });
            }
        },

        addDevice: function () {
            this.site.devices.push({
                zone: "",
                detector_no: "",
                type: "",
                location: "",
                year: window.moment().format("YYYY"),
            });
        },

        removeDevice: function (index) {
            const confirm = window.confirm(
                "Are you sure you want to delete this device?"
            );
            if (!confirm) {
                return;
            }
            this.site.devices.splice(index, 1);
        },

        handleDeviceImport: function (devices) {
            if (devices.length === 0) {
                return;
            }

            if (this.site.devices.length > 0) {
                const confirm = window.confirm("Importing will overwrite existing devices. Do you want to continue?");

                if (!confirm) {
                    return;
                }
            }

            this.site.devices = [...devices];
        },

        openAddLightModal() {
            this.$refs.lightModal.open({
                mode: "add",
                light: {},
                index: null,
            });
        },

        openEditLightModal(index) {
            this.$refs.lightModal.open({
                mode: "edit",
                light: this.site.lights[index],
                index,
            });
        },

        saveLightFromModal(payload) {
            const normalizedLight = this.normalizeLight(payload.light);
            normalizedLight._is_existing_light = false;
            if (payload.mode === "edit" && payload.index !== null) {
                this.site.lights.splice(payload.index, 1, normalizedLight);
            } else {
                this.site.lights.push(normalizedLight);
            }
            this.$forceUpdate();
        },

        promptLightDeletion(index) {
            const confirm = window.confirm(
                "Are you sure you want to delete this light?"
            );
            if (!confirm) {
                return;
            }
            const light = this.site.lights[index];
            this.deleteLightImageIfUnreferenced(light.photo_url, index).then(() => {
                this.site.lights.splice(index, 1);
                this.$forceUpdate();
            });
        },

        deleteLightImageIfUnreferenced(photoUrl, deletingIndex) {
            if (!photoUrl) {
                return Promise.resolve();
            }
            const matches = this.site.lights.filter((light, index) => {
                if (index === deletingIndex) {
                    return false;
                }
                return light && light.photo_url === photoUrl;
            });
            if (matches.length > 0) {
                return Promise.resolve();
            }
            return UploadService.delete(photoUrl).catch(() => {});
        },

        getProductVariations: function (product_id) {
            var product = this.products.find(
                (product) => product.id === product_id
            );
            if (typeof product === "undefined") {
                return [];
            }

            return product.variations;
        },

        loadProducts: function () {
            ProductsService.index({}).then(
                (xhr) => {
                    this.products = xhr.data;
                },
                (err) => {
                    alert("Failed to load service products");
                }
            );
        },

        addServiceItem: function () {
            this.site.service_items.push({});
        },

        removeServiceItem: function (index) {
            const confirm = window.confirm(
                "Are you sure you want to delete this item?"
            );
            if (!confirm) {
                return;
            }
            this.site.service_items.splice(index, 1);
        },

        serviceItemChanged: function (index) {
        },

        addReminder() {
            if (!this.site.service_reminders) {
                this.site.service_reminders = [];
            }

            this.site.service_reminders.push({
                type: null,
                month: null,
                notes: "",
            });
            this.$forceUpdate();
        },

        removeReminder(index) {
            let confirm = window.confirm(
                "Are you sure you want to delete this sevice reminder?"
            );
            if (!confirm) {
                return;
            }

            this.site.service_reminders.splice(index, 1);
            this.$forceUpdate();
        },

        isDeviceInvalid(device) {
            return !device.location || device.location === "";
        },

        getServiceFee() {
            PostcodeFeeService.search({
                site_id: this.site.id,
                customer_id: this.customer_id,
            }).then((res) => {
                if (!res.data) {
                    this.setInfoMessage(
                        "Could not find a service postcode for this site"
                    );
                    return;
                }

                const postcodeFee = res.data[0];
                if (
                    postcodeFee !== null &&
                    typeof postcodeFee !== "undefined"
                ) {
                    this.serviceFee = postcodeFee.service_fee;
                    this.unitServiceFee = postcodeFee.unit_fee;
                    this.calculateServiceItemCosts();
                }

                this.$forceUpdate();
            });
        },

        calculateServiceItemCosts() {
            if (!this.site || !this.site.service_items) {
                return;
            }
            this.site.service_items = this.site.service_items.map((item) => {
                item.cost = item.service_fee;
                if (this.unitServiceFee && !item.es_required) {
                    item.cost = this.unitServiceFee;
                }
                if (this.unitServiceFee && item.es_required) {
                    item.cost += this.unitServiceFee;
                }

                return item;
            });
        },

        removeBattery(index) {
            this.site.batteries.splice(index, 1);
            this.$forceUpdate();
        },

        addBattery() {
            this.site.batteries.push({});
        },

        siteProductsChanged(siteProducts) {
            this.site.products = siteProducts;
        },
        uploadChanged(url, prop) {
            this.site[prop] = `${url}?time=${Date.now()}`
        },
        addNurseCallDevice() {
            this.site.nurse_call_devices.push({
                number: '',
                type: '',
                location: '',
            });
        },
        removeNurseCallDevice(index) {
            this.site.nurse_call_devices.splice(index, 1);
        },
        addDomesticFireAlarmDevice() {
            if (!Array.isArray(this.site.domestic_fire_alarm_devices)) {
                this.site.domestic_fire_alarm_devices = [];
            }
            this.site.domestic_fire_alarm_devices.push({
                device_no: "",
                location: "",
                interlink_test: "",
                install_date: "",
                battery_date: "",
            });
        },
        removeDomesticFireAlarmDevice(index) {
            this.site.domestic_fire_alarm_devices.splice(index, 1);
        },
    },
};
</script>

<style scoped lang="scss">
.site-photo {
    display: block;
    padding: 10px;
    background: white;
    border: 1px solid lightgray;
    margin: 5px 0;
}

.row {
    margin-bottom: 1rem;
}

.lighting-table {
    tr.invalid {
        background: #ffd3d3;
    }

    .td {
        padding: 5px 2px;

        &-sw-no {
            width: 4rem;
        }
        &-light-no {
            width: 4rem;
        }
        &-maintained {
            width: 3rem;
            text-align: center;
        }
        &-type {
            width: 9rem;
        }
        &-buttons {
            width: 5.5rem;
            text-align: center;
        }
    }
}

.light-type-display {
    display: flex;
    align-items: center;
    gap: 0.4rem;

    &__image {
        width: 2rem;
        height: 2rem;
        object-fit: cover;
        border: 1px solid #ddd;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/office/sites/SiteComponent.vue